// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"AnimateTextUnderline_textWrapper__16ChM","underline":"AnimateTextUnderline_underline__3MD98","underlineFill":"AnimateTextUnderline_underlineFill__1ahFS"};